const base = {
    indexinfo:'/api/index',


    // 登录接口
    login:"/login/login",
    getWeChatUrl:'/login/getWeChatUrl',
    islogin:'/login/islogin',
    repwd:"/login/repwd",

    //全新机批发
    sortBrandnewList:"/brandnew/sortBrandnewList",
    addBrandnewSort:"/brandnew/addBrandnewSort",
    deleBrandnewSort:"/brandnew/deleBrandnewSort",

    allsortBrandnewList:"/brandnew/allsortBrandnewList",
    modelBrandnewList:"/brandnew/modelBrandnewList",
    addBrandnewModel:"/brandnew/addBrandnewModel",
    deleBrandnewModel:"/brandnew/deleBrandnewModel",

    outbrandnewExcel:"/brandnew/outbrandnewExcel",
    inbrandnewExcel:"/brandnew/inbrandnewExcel",
    
    Bncollection:"/brandnew/Bncollection",


    // 物料管理
    getSupplierinfo:"/material/getSupplierinfo",
    material:'/material/MaterialList',
    hswiper:'/material/hswiper',

    colorList:"/material/colorList",
    addColor:"/material/addColor",
    editColor:"/material/editColor",
    deleColor:"/material/deleColor",

    memoryList:'/material/memoryList',
    addMemory:'/material/addMemory',
    editMemory:'/material/editMemory',
    deleMemory:'/material/deleMemory',
   
    edithuifu:'/material/edithuifu',   //设置支付
    
    //快递管理
    expressList:"/express/expressList",
    editExpress:"/express/editExpress",
    deleExpress:"/express/deleExpress",

    
 

}

export default base